"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.VoteOfNoConfidence = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var constants_1 = require("../../constants");
var Card_1 = require("../Card");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var VoteOfNoConfidence = (function (_super) {
    __extends(VoteOfNoConfidence, _super);
    function VoteOfNoConfidence() {
        return _super.call(this, {
            name: CardName_1.CardName.VOTE_OF_NO_CONFIDENCE,
            cardType: CardType_1.CardType.EVENT,
            cost: 5,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.partyLeaders(); }),
            metadata: {
                cardNumber: 'T16',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.minus().chairman().any.asterix();
                    b.nbsp.plus().partyLeaders().br;
                    b.tr(1);
                }),
                description: 'Requires that you have a Party Leader in any party and that the sitting Chairman is neutral. ' +
                    'Remove the NEUTRAL Chairman and move your own delegate (from the reserve) there instead. Gain 1 TR.',
            },
        }) || this;
    }
    VoteOfNoConfidence.prototype.canPlay = function (player) {
        if (!_super.prototype.canPlay.call(this, player)) {
            return false;
        }
        if (player.game.turmoil !== undefined) {
            if (!player.game.turmoil.hasAvailableDelegates(player.id))
                return false;
            var chairmanIsNeutral = player.game.turmoil.chairman === 'NEUTRAL';
            if (chairmanIsNeutral === false) {
                return false;
            }
            if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
                return player.canAfford(player.getCardCost(this) + constants_1.REDS_RULING_POLICY_COST);
            }
            return true;
        }
        return false;
    };
    VoteOfNoConfidence.prototype.play = function (player) {
        if (player.game.turmoil !== undefined) {
            player.game.turmoil.chairman = player.id;
            var index = player.game.turmoil.delegateReserve.indexOf(player.id);
            if (index > -1) {
                player.game.turmoil.delegateReserve.splice(index, 1);
            }
            player.increaseTerraformRating();
        }
        return undefined;
    };
    return VoteOfNoConfidence;
}(Card_1.Card));
exports.VoteOfNoConfidence = VoteOfNoConfidence;
//# sourceMappingURL=VoteOfNoConfidence.js.map